import React from 'react';
import {connect} from "react-redux";
import {WithModal} from '../';
import {BA, Cell, EK, EnergoAll, WinterSummer} from '../entries'
import * as trends from '../../trends.js';
import styles from './style.css';

const cellData = [
    {
        ps: ['ti_8_96_3'],
        chartPs: trends.teplo_t3,
        div_id: styles.Cell2,
        caption: "T °C",
        hint: "Т3 - температура наружного воздуха"
    },
    {
        ps: ['ti_8_96_5'],
        chartPs: trends.teplo_t5,
        div_id: styles.Cell1,
        caption: "T °C",
        hint: "Т5 - температура в узле ВЕНА"
    },
    {ps: ['ti_8_127_7'], div_id: styles.Cell3, caption: "Ртп(кВт)", hint: "Ртп - мощность потерь текущая"},
    {ps: ['ti_8_127_8'], div_id: styles.Cell4, caption: "Рпп(кВт)", hint: "Рпп - мощность потерь за прошедший час"},
    {ps: ['ti_8_127_1'], div_id: styles.Cell5, caption: "Ртг(кВт)", hint: "Ртг - мощность генерации текущая"},
    {ps: ['ti_8_127_2'], div_id: styles.Cell6, caption: "Рпг(кВт)", hint: "Рпг - мощность за прошедший час"},
    {ps: ['ti_8_127_3'], div_id: styles.Cell7, caption: "Ртн(кВт)", hint: "Ртн - мощность потребления текущая"},
    {
        ps: ['ti_8_127_4'],
        div_id: styles.Cell8,
        caption: "Рпн(кВт)",
        hint: "Рпн - мощность потребления за прошедший час"
    },
    {ps: ['ti_8_127_9'], div_id: styles.Cell9, caption: "Тз (часов)", hint: "Тз - запас хода в баке"},
    {ps: ['ti_8_127_5'], div_id: styles.Cell10, caption: "Wз (кВт*ч)", hint: "Wз - запас энергии в баке"},
    {ps: ['ti_8_127_6'], div_id: styles.Cell11, caption: "Wд (кВт*ч)", hint: "Wд -дефицит энергии в баке"},
    {
        ps: ['ti_8_96_1'],
        chartPs: trends.teplo_t1,
        div_id: styles.Cell12,
        caption: "T °C",
        hint: "Т1 - температура в баке аккумуляторе"
    }

];

export class Energo extends WithModal {
    render() {
        const chart = super.render();
        return (

            <div className={[this.props.className, "row col-md-12 ", styles.App].join(' ')}>
                <div className={styles.canvases}>
                    <EnergoAll canvas_id={styles.canvas0}/>
                    <EK ps={[this.props.params['tc_8_97_44'], this.props.params['tc_8_92_201']]}
                        canvas_id={styles.canvas1}/>
                    <EK ps={[this.props.params['tc_8_97_45'], this.props.params['tc_8_93_201']]}
                        canvas_id={styles.canvas2}/>
                    <BA ps={[this.props.params['tc_8_97_47'], this.props.params['tc_8_97_77'],
                        this.props.params['tc_8_97_46']]}
                        div_id={styles.canvas3}
                        canvas_id="Random1490"/>
                    <WinterSummer winter={this.props.params['tc_8_97_21']} div_id={styles.canvas4}/>

                    {
                        cellData.map(function (childData, i) {

                            return <Cell {...this.props}
                                         key={'energo' + i}
                                         onClick={childData.chartPs && this.openModal.bind(this, childData.chartPs)}
                                         ps={this.props.params[childData.ps]}
                                         div_id={childData.div_id}
                                         caption={childData.caption}
                                         hint={childData.hint}
                                         className={childData.className}
                            />
                        }.bind(this))
                    }

                    <div className="capt" id={styles.capt1}>Температура в узле ВЕНА</div>
                    <div className="capt" id={styles.capt2}>Температура зовнішнього повітря</div>
                    <div className="capt" id={styles.capt3}>ЕК1</div>
                    <div className="capt" id={styles.capt4}>ЕК2</div>
                    <div className="capt" id={styles.capt5}>НАГРУЗКА</div>


                    {chart}
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <p>
                            Ртп - мощность потерь в текущее время<br/>
                            Рпп - мощность потерь за прошедший час<br/>
                            Тз - запас хода в баке аккумуляторе<br/>
                            Wз - запас энергии в баке аккумуляторе<br/>
                            Wд -дефицит энергии в баке аккумуляторе
                        </p>
                    </div>
                    <div className="col-md-6">
                        <p>
                            Ртг - мощность генерируемая котлом в текущее время<br/>
                            Рпг - мощность сгненерированная котлом за прошедший час<br/>
                            Ртн - мощность потребляемая нагрузкой в текущее время<br/>
                            Рпн - мощность потребленная нагрузкой за прошедший час
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        params: state.params
    };
};

export default connect(mapStateToProps)(Energo);




// WEBPACK FOOTER //
// ./src/components/Energo/index.jsx